<template>
  <Dialog :title="`Vælg konfliktløsning`" size="lg" confirm="Løs konflikter" :confirmDisabled="!resolution" @close="handleClose">
    <template #content>
      <ul class="flex flex-col gap-4">
        <li v-for="option in options" :key="option.value">
          <label
            class="block cursor-pointer bg-white rounded-md border ring-1 border-gray-300 shadow-sm p-6 hover:bg-gray-50 transition-all"
            :class="resolution === option.value ? 'border-blue-600 ring-blue-600' : 'ring-transparent '"
          >
            <input :id="option.value" v-model="resolution" type="radio" name="resolution" :value="option.value" class="hidden" />
            <div class="flex">
              <div class="relative mr-4 inline-block">
                <div
                  class="relative size-4 rounded-sm ring-2 ring-white"
                  :class="[
                    option.value.includes('conflict') && 'z-10',
                    option.value === 'delete:stayEvents' ? 'bg-gray-50 border-2 border-dotted border-gray-300' : 'bg-gray-300',
                  ]"
                ></div>
                <div
                  class="absolute left-1.5 top-1.5 size-4 rounded-sm ring-2 ring-white"
                  :class="option.value === 'delete:conflicts' ? 'bg-red-50 border-2 border-dotted border-red-400' : 'bg-red-500 '"
                ></div>
              </div>
              <div>
                <p>{{ option.label }}</p>
                <span class="text-xs font-normal text-gray-500">
                  {{ getDescriptionFor(option) }}
                </span>
              </div>
            </div>
          </label>
        </li>
      </ul>
    </template>
  </Dialog>
</template>

<script>
import { uniqBy } from "lodash";
import { getConflictResolution } from "~/components/conflicts/utils/getConflictResolution";
import { getStayId } from "~/components/conflicts/utils/getStayId";
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },

  props: {
    stayEvents: {
      type: Array,
      required: true,
    },

    conflicts: {
      type: Array,
      required: true,
    },
  },

  emits: ["close"],

  data() {
    return {
      resolution: null,
    };
  },

  computed: {
    options() {
      return getConflictResolution(this.stayEvents, this.conflicts);
    },

    allStayEvents() {
      return this.stayEvents.concat(this.conflicts);
    },
  },

  methods: {
    getDescriptionFor(option) {
      if (option.value.includes("delete")) {
        const stayEvents = this.allStayEvents.filter((se) => option.payload.includes(se.hexdigest));
        const uniqStays = uniqBy(stayEvents, getStayId).length;

        return `Fjerner ${uniqStays} ${uniqStays === 1 ? "elev" : "elever"} fra ${stayEvents.length} ${stayEvents.length === 1 ? "begivenhed" : "begivenheder"}`;
      } else if (option.value.includes("startTime")) {
        return Object.entries(option.payload)
          .map(([time, hexdigests]) => {
            const stayEvents = this.allStayEvents.filter((se) => hexdigests.includes(se.hexdigest));
            const uniqStays = uniqBy(stayEvents, getStayId).length;

            return `Ændrer starttid til ${time} for ${uniqStays} ${uniqStays === 1 ? "elev" : "elever"} fra ${stayEvents.length} ${stayEvents.length === 1 ? "begivenhed" : "begivenheder"}`;
          })
          .join(", ");
      } else if (option.value.includes("endTime")) {
        return Object.entries(option.payload)
          .map(([time, hexdigests]) => {
            const stayEvents = this.allStayEvents.filter((se) => hexdigests.includes(se.hexdigest));
            const uniqStays = uniqBy(stayEvents, getStayId).length;

            return `Ændrer sluttid til ${time} for ${uniqStays} ${uniqStays === 1 ? "elev" : "elever"} fra ${stayEvents.length} ${stayEvents.length === 1 ? "begivenhed" : "begivenheder"}`;
          })
          .join(", ");
      }
    },

    handleClose(confirmed) {
      if (!confirmed) {
        this.$emit("close", null);
      } else {
        const option = this.options.find((o) => o.value === this.resolution);
        const { value, payload } = option;
        this.$emit("close", { type: value, payload });
      }
    },
  },
};
</script>
